/*
* JavaScript 共通処理
*/

import Vue from 'vue';
import platform from 'platform';

// mixinでVueコンポーネントのどこからでも呼び出し可能。
Vue.mixin({
	data() {
		return {
			isWin: (platform.os.family.toLowerCase() == 'windows'),
			isFF: (platform.name.toLowerCase() == 'firefox'),
			isIE11: (platform.name.toLowerCase() == 'ie' && parseInt(platform.version) == 11),
			isEdge: (platform.name.toLowerCase().indexOf('edge') > -1),
			isChrome: (platform.name.toLowerCase() == 'chrome'),
			isSafari: (platform.name.toLowerCase() == 'safari'),
			isOpera: (platform.name.toLowerCase() == 'opera'),
		}
	}
});



// WEBPACK FOOTER //
// ./src/js/common.js